import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const UnsavedChangesModal = ({ open, onClose, onConfirm }: Props) => {
  const { t } = useTranslation(["boCustoms", "common"]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-amber-100">
            <TriangleAlert className="size-5 text-amber-600" />
          </div>
          <span>{t("unsavedChangesModal.title")}</span>
        </div>
      }
      description={t("unsavedChangesModal.description")}
      footer={
        <div className="flex w-full gap-2">
          <Button type="button" variant="outline" onClick={onClose} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} className="flex-1">
            {t("unsavedChangesModal.confirm")}
          </Button>
        </div>
      }
    />
  );
};
